import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { MocketBankAccount } from '@shared/models';
import { AccessControlPipe } from '@shared/pipes';

export type MocketBankDetailsAction = 'SUSPEND' | 'DELETE' | 'UNSUSPEND';

@Component({
  selector: 'app-mocketbnk-details-header',
  imports: [AsyncPipe, AccessControlPipe, RktIconComponent],
  templateUrl: './mocketbnk-details-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class MocketbnkDetailsHeaderComponent {
  @Input() mocketBankAccount!: MocketBankAccount | null;

  @Input() isControlsDisabled = true;

  @Output() btnClicked = new EventEmitter<MocketBankDetailsAction>();
}
